/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { CourseModuleSettingsOutputModuleId } from './courseModuleSettingsOutputModuleId';
import type { CourseModuleSettingsOutputSortIndex } from './courseModuleSettingsOutputSortIndex';
import type { CourseModuleSettingsOutputAllowPartialSubmission } from './courseModuleSettingsOutputAllowPartialSubmission';
import type { CourseModuleSettingsOutputEcts } from './courseModuleSettingsOutputEcts';
import type { CourseModuleSettingsOutputLearningHours } from './courseModuleSettingsOutputLearningHours';
import type { CourseModuleSettingsOutputExamTaskIds } from './courseModuleSettingsOutputExamTaskIds';
import type { CourseModuleSettingsOutputSegmentId } from './courseModuleSettingsOutputSegmentId';
import type { CourseModuleSettingsOutputEnabledEventKinds } from './courseModuleSettingsOutputEnabledEventKinds';
import type { CourseModuleSettingsOutputMandates } from './courseModuleSettingsOutputMandates';

/**
 * Properties of a Module in a Course
 */
export interface CourseModuleSettingsOutput {
  moduleId?: CourseModuleSettingsOutputModuleId;
  sortIndex?: CourseModuleSettingsOutputSortIndex;
  allowPartialSubmission?: CourseModuleSettingsOutputAllowPartialSubmission;
  ects?: CourseModuleSettingsOutputEcts;
  learningHours?: CourseModuleSettingsOutputLearningHours;
  examTaskIds?: CourseModuleSettingsOutputExamTaskIds;
  segmentId?: CourseModuleSettingsOutputSegmentId;
  enabledEventKinds?: CourseModuleSettingsOutputEnabledEventKinds;
  mandates?: CourseModuleSettingsOutputMandates;
}
